import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
	CompanyNameWrapper,
	InsightsBackgroundWrapper,
	InsightsInfoWrapper,
	InsightsWrapper,
	LoadingContainer,
	LogoWrapper,
	ModulesBackgroundWrapepr,
	ModulesInfoWrapper,
	ModulesWrapper,
	SectionWrapper,
	TableWrapper,
	TitleWrapper,
	Wrapper,
} from './SectionOne.styles';
import { Heading } from 'LandingPage/style/CommonStyles';
import SpendAnalysisImg from '../../assets/images/Spend_Analysis2.png';
import BenchmarkImg from '../../assets/images/Benchmarking.png';
import DiversityReportImg from '../../assets/images/Market_Analysis.png';
import InitiativesImg from '../../assets/images/Spend_Controller.png';
import CategoryManagementImg from '../../assets/images/Manage_Category.png';
import ApVendorDBImg from '../../assets/images/Speed_to_Market.png';
import APIcon from '../../assets/images/ap-icon.png';
import {
	ApButtonIcon,
	ApButtonMain,
	ApLoaderDefault,
	ApLoaderText,
	ApModal,
	ApToggleSwitch,
} from '@alixpartners/ui-components';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { AgGridReact } from '@ag-grid-community/react';
import { getLocalStorageItem, setLocalStorageItem } from 'utils/localStorage';
import { ReactComponent as TotalSpendSVG } from '../../assets/svg/total-spend-dark.svg';
import { ReactComponent as VendorSVG } from '../../assets/svg/vendor-dark.svg';
import { ReactComponent as TailSpendSVG } from '../../assets/svg/total-tail-spend-dark.svg';
import { ReactComponent as DiversitySVG } from '../../assets/svg/total-diversity-spend-dark.svg';
import { ReactComponent as BenchmarkSVG } from './../../assets/svg/benchmark-dark.svg';
import { ReactComponent as BussinessUnitSVG } from '../../assets/svg/Business unit.svg';
import { ReactComponent as CostCenterSVG } from '../../assets/svg/cost-centre-dark.svg';
import { ReactComponent as SavingsSVG } from '../../assets/svg/saving-initiatives-dark.svg';
import { ReactComponent as SavingEstimateSVG } from '../../assets/svg/Savings estimates.svg';
import { ReactComponent as GeoSVG } from '../../assets/svg/geo-dark.svg';
import { getKPI, getTailSpendAnalysisData } from 'utils/apiRequests';
import { SpendCubeSettingsContext } from 'contexts/SpendCubeSettingsContext';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { formatNumber, formatSpendWithDecimalAndSymbol } from 'utils/number';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { getCurrencySymbolFromOptions } from 'Investigate/utils';
import BenchmarkModule from 'LandingPage/components/ModulesSection/Benchmark/BenchmarkModule';
import SupplierDiversityModule from 'LandingPage/components/ModulesSection/SupplierDiversity/SupplierDiversityModule';
import CategoryManagementModule from 'LandingPage/components/ModulesSection/CategoryManagementModule/CategoryManagementModule';
import APVendorDBModule from 'LandingPage/components/ModulesSection/APVendorDBModule/APVendorDBModule';
import InitiativesModule from 'LandingPage/components/ModulesSection/InitiativesModule/InitiativesModule';
import AnalysisModule from 'LandingPage/components/ModulesSection/AnalysisModule/AnalysisModule';
import { SettingsContext } from 'contexts/SettingsContext';
import DynamicGrid from 'LandingPage/components/DynamicGrid/DynamicGrid';
import { getMonthYearRange } from 'utils/date.js';

const KPIConfig = [
	{
		id: 1,
		KPIName: 'Total Spend',
		isVisible: true,
	},
	{
		id: 2,
		KPIName: 'Diversity Vendors',
		isVisible: true,
	},
	{
		id: 3,
		KPIName: 'Business Unit',
		isVisible: true,
	},
	{
		id: 4,
		KPIName: 'Tail Spend Vendors',
		isVisible: true,
	},
	{
		id: 5,
		KPIName: 'Vendors Increased/Decreased',
		isVisible: true,
	},
	{
		id: 6,
		KPIName: 'Addressable Spend',
		isVisible: true,
	},
	{
		id: 7,
		KPIName: 'Benchmarks',
		isVisible: true,
	},
	{
		id: 8,
		KPIName: 'Cost Centre',
		isVisible: false,
	},
	{
		id: 9,
		KPIName: 'Savings Initiative',
		isVisible: false,
	},
	{
		id: 10,
		KPIName: 'Geo',
		isVisible: false,
	},
];

const keyToSaveSettings = 'clientInsights';

const toPercentage = (value, isFraction = true) => {
	let percentage = isFraction ? value * 100 : value;
	return percentage.toFixed(2) + '%';
};

const SectionOne = () => {
	const { companyName } = useContext(SettingsContext);
	const {
		options: { currency: currencyList },
	} = useContext(SettingsOptionsContext);
	const { currency, dateFrom, dateTo, currencyType } = useContext(
		QueryStringContext
	);
	const currencySymbol = getCurrencySymbolFromOptions(currencyList, currency);
	const { settings } = useContext(SpendCubeSettingsContext);
	const { tailSpend, tailSpendAnalysisConfiguration } = settings;

	const analysisDateRamge = getMonthYearRange(dateFrom, dateTo);

	const InitialKpiData = [
		{
			id: 1,
			name: 'Total Spend',
			isVisible: true,
			icon: TotalSpendSVG,
			heading: 0,
			description: ['Total spend over', `${analysisDateRamge}`],
		},
		{
			id: 2,
			name: 'Diversity Vendors',
			isVisible: true,
			icon: DiversitySVG,
			heading: 0,
			description: [
				'Of total spend is',
				'covered by diversity vendors for',
				`${analysisDateRamge}`,
			],
		},
		{
			id: 3,
			name: 'Business Unit',
			isVisible: true,
			icon: BussinessUnitSVG,
			heading: 0,
			description: ['0', 'Business unit has highest spend'],
		},
		{
			id: 4,
			name: 'Tail Spend Vendors',
			isVisible: true,
			icon: TailSpendSVG,
			heading: 0,
			description: ['Tail spend vendors', `for ${analysisDateRamge}`],
		},
		{
			id: 5,
			name: 'Vendors Increased/Decreased',
			isVisible: true,
			icon: VendorSVG,
			heading: 0,
			description: ['Vendors increase in a year'],
		},
		{
			id: 6,
			name: 'Addressable Spend',
			isVisible: true,
			icon: SavingsSVG,
			heading: 0,
			description: ['Of total addressable spend ', 'top 15 vendor covers'],
		},
		{
			id: 7,
			name: 'Benchmarks',
			isVisible: true,
			icon: BenchmarkSVG,
			heading: 'Benchmarks',
			description: ['0'],
		},
		{
			id: 8,
			name: 'Cost Center',
			isVisible: true,
			icon: CostCenterSVG,
			heading: null,
			description: [`Spend over ${analysisDateRamge}`, 'for a top cost center'],
		},
		{
			id: 9,
			name: 'Savings Estimates',
			isVisible: false,
			icon: SavingEstimateSVG,
			heading: null,
			description: ['Initial outside-in savings estimates'],
		},
		{
			id: 10,
			name: 'Geo',
			isVisible: false,
			icon: GeoSVG,
			heading: 'Geo',
			description: [''],
		},
	];

	const [isLoading, setIsLoading] = useState(true);
	const [kpiData, setKpiData] = useState(InitialKpiData);
	const [SettingsModal, setSettingsModal] = useState(false);
	const [modalRowData, setModalRowData] = useState(
		getLocalStorageItem(keyToSaveSettings) === null
			? KPIConfig
			: JSON.parse(getLocalStorageItem(keyToSaveSettings))
	);

	useEffect(
		() => {
			if (getLocalStorageItem(keyToSaveSettings) === null) {
				setLocalStorageItem(keyToSaveSettings, JSON.stringify(KPIConfig));
			}
			loadStats();
		}, // eslint-disable-next-line
		[]
	);

	function getIsVisibleById(data, id) {
		const kpi = data.find(item => item.id === id);
		if (kpi) {
			return kpi.isVisible;
		} else {
			console.error(`No KPI found with id ${id}`);
			return false;
		}
	}

	const loadStats = async () => {
		const payload = {
			totalTailSpendVendors: tailSpend.value,
			harmonized: true,
			Skip: 0,
			Take: 9,
			dateFrom: dateFrom,
			dateTo: dateTo,
			currency: currency,
			currencyType: currencyType,
			indirectTaxonomyType: 3,
			directTaxonomyType: 1,
			includeTailSpend: false,
			getTailSpendOnly: false,
			calculateTailSpend: false,
			filters: ['sourceable', 'spendType'],
			splitSpendByDimension: 0,
		};

		try {
			const [response, tailVendorResponse] = await Promise.all([
				getKPI(payload),
				getTailSpendAnalysisData({
					tailSpendValue: tailSpend?.value || 0,
					tailSpendType: tailSpend?.type || 0,
					dateFrom: dateFrom,
					dateTo: dateTo,
					calculationType: tailSpendAnalysisConfiguration?.calculationType,
					useNetSpend: tailSpend?.useNetSpend,
					harmonized: tailSpendAnalysisConfiguration?.harmonized,
				}),
			]);
			if (response.succeeded && Object.keys(tailVendorResponse).length > 0) {
				if (response.data !== null) {
					if (response.data.length > 0) {
						setKpiData(prevKpiData => {
							const newKpiData = [...prevKpiData];

							// 1
							newKpiData[0] = {
								...newKpiData[0],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(x => x.insightType === 'Total Spend')[0]
										?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
							};

							// 2
							newKpiData[1] = {
								...newKpiData[1],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Total Diversity Spend'
									)[0]?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
							};

							// 3
							newKpiData[2] = {
								...newKpiData[2],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Business Unit'
									)[0]?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
								description: [
									response.data?.filter(
										x => x.insightType === 'Business Unit'
									)[0]?.value2,
									'business unit has highest spend',
								],
							};

							//4
							newKpiData[3] = {
								...newKpiData[3],
								heading: formatNumber(
									tailVendorResponse?.tailVendorsCount || 0
								),
							};

							//5
							newKpiData[4] = {
								...newKpiData[4],
								heading: formatNumber(
									response.data?.filter(
										x => x.insightType === 'Vendor Change'
									)[0]?.value1
								),
								description:
									response.data?.filter(
										x => x.insightType === 'Vendor Change'
									)[0]?.value2 === 'invalid'
										? [
												`${
													response.data?.filter(
														x => x.insightType === 'Vendor Change'
													)[0]?.insightText
												}`,
										  ]
										: [
												`Vendor ${
													response.data.filter(
														x => x.insightType === 'Vendor Change'
													)[0].value2
												} for ${analysisDateRamge}`,
										  ],
							};

							// 6
							newKpiData[5] = {
								...newKpiData[5],
								heading: toPercentage(
									response.data?.filter(
										x => x.insightType === 'Top 15 Vendors Coverage'
									)[0]?.value2,
									false
								),
							};

							// 7
							const benchmarkStatus = generateBenchmarkAnalysis(
								response.data.filter(x => x.insightType === 'Benchmark')[0]
									?.matchedObjects
							);
							if (Object.keys(benchmarkStatus).length > 0) {
								newKpiData[6] = {
									...newKpiData[6],
									description: benchmarkStatus,
								};
							} else {
								newKpiData[6] = {
									...newKpiData[6],
									isVisible: false,
								};
							}

							// 8
							newKpiData[7] = {
								...newKpiData[7],
								heading: formatSpendWithDecimalAndSymbol(
									response.data?.filter(x => x.insightType === 'Cost Center')[0]
										?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase(),
								description: [
									`Spend over ${analysisDateRamge}`,
									`for cost center-${
										response.data?.filter(
											x => x.insightType === 'Cost Center'
										)[0]?.value2
									}`,
								],
							};

							// 9
							newKpiData[8] = {
								...newKpiData[8],
								heading: `${formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Savings Initiatives'
									)[0]?.value1,
									currencySymbol,
									true,
									1
								).toUpperCase()} - ${formatSpendWithDecimalAndSymbol(
									response.data?.filter(
										x => x.insightType === 'Savings Initiatives'
									)[0]?.value2,
									currencySymbol,
									true,
									1
								).toUpperCase()}`,
							};

							// 10
							const geoStatus = generateGeoAnalysis(
								response.data?.filter(x => x.insightType === 'Geo')[0]?.geo
							);
							if (Object.keys(geoStatus).length > 0) {
								newKpiData[9] = {
									...newKpiData[9],
									description: geoStatus,
								};
							}

							return newKpiData;
						});

						let savedPreference = getLocalStorageItem(keyToSaveSettings);
						savedPreference = JSON.parse(savedPreference);
						setModalRowData(prevRowData => {
							const newRowData = [...prevRowData];
							// 1
							const totalSpend = response.data?.filter(
								x => x.insightType === 'Total Spend'
							)[0]?.value1;
							newRowData[0] = {
								...newRowData[0],
								isVisible:
									totalSpend === 0 || totalSpend === null
										? false
										: getIsVisibleById(savedPreference, 1),
							};

							// 2
							const diversitySpend = response.data?.filter(
								x => x.insightType === 'Total Diversity Spend'
							)[0]?.value1;
							newRowData[1] = {
								...newRowData[1],
								isVisible:
									diversitySpend === 0 || diversitySpend === null
										? false
										: getIsVisibleById(savedPreference, 2),
							};

							// 3
							const businessUnit = response.data?.filter(
								x => x.insightType === 'Business Unit'
							)[0]?.value1;
							newRowData[2] = {
								...newRowData[2],
								isVisible:
									businessUnit === 0 || businessUnit === null
										? false
										: getIsVisibleById(savedPreference, 3),
							};

							//4
							const tailVendors = response.data?.filter(
								x => x.insightType === 'Total Tail Spend Vendors'
							)[0]?.value1;
							newRowData[3] = {
								...newRowData[3],
								isVisible:
									tailVendors === 0 || tailVendors === null
										? false
										: getIsVisibleById(savedPreference, 4),
							};

							//5
							const vendorChange = response.data?.filter(
								x => x.insightType === 'Vendor Change'
							)[0]?.value1;
							newRowData[4] = {
								...newRowData[4],
								isVisible:
									vendorChange === 0 || vendorChange === null
										? false
										: getIsVisibleById(savedPreference, 5),
							};

							// 6
							const vendorCoverage = response.data?.filter(
								x => x.insightType === 'Top 15 Vendors Coverage'
							)[0]?.value2;
							newRowData[5] = {
								...newRowData[5],
								isVisible:
									vendorCoverage === 0 || vendorCoverage === null
										? false
										: getIsVisibleById(savedPreference, 6),
							};

							// 7
							const benchmarkStatus = generateBenchmarkAnalysis(
								response.data.filter(x => x.insightType === 'Benchmark')[0]
									?.matchedObjects
							);
							if (Object.keys(benchmarkStatus).length > 0) {
								newRowData[6] = {
									...newRowData[6],
									description: benchmarkStatus,
									isVisible: getIsVisibleById(savedPreference, 7),
								};
							} else {
								newRowData[6] = {
									...newRowData[6],
									isVisible: false,
								};
							}

							// 8
							const costCenters = response.data?.filter(
								x => x.insightType === 'Cost Center'
							)[0]?.value1;
							newRowData[7] = {
								...newRowData[7],
								isVisible:
									costCenters === 0 || costCenters === null
										? false
										: getIsVisibleById(savedPreference, 8),
							};

							// 9
							const savingsInitiative = response.data?.filter(
								x => x.insightType === 'Savings Initiatives'
							)[0]?.value1;
							newRowData[8] = {
								...newRowData[8],
								isVisible:
									savingsInitiative === 0 || savingsInitiative === null
										? false
										: getIsVisibleById(savedPreference, 9),
							};

							// 10
							const geoStatus = generateGeoAnalysis(
								response.data?.filter(x => x.insightType === 'Geo')[0]?.geo
							);
							if (Object.keys(geoStatus).length > 0) {
								newRowData[9] = {
									...newRowData[9],
									description: geoStatus,
									isVisible: getIsVisibleById(savedPreference, 10),
								};
							} else {
								newRowData[9] = {
									...newRowData[9],
									isVisible: false,
								};
							}
							setLocalStorageItem(
								keyToSaveSettings,
								JSON.stringify(newRowData)
							);
							return newRowData;
						});
					}
				}
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleToggleCard = id => {
		setModalRowData(prevItems =>
			prevItems.map(
				kpi => (kpi.id === id ? { ...kpi, isVisible: !kpi.isVisible } : kpi)
			)
		);
	};

	const columnDefs = [
		{
			field: 'KPIName',
			headerName: 'KPI',
		},
		{
			field: 'isVisible',
			headerName: 'Action',
			cellRendererFramework: params => (
				<>
					<ApToggleSwitch
						checked={params.data.isVisible}
						onChange={() => handleToggleCard(params.data.id)}
					/>
				</>
			),
		},
	];

	const getGridOptions = () => {
		return {
			modules: AllModules,
			defaultColDef: {
				suppressMenu: true,
				flex: 1,
				comparator: () => 0,
			},
			rowData: modalRowData,
			columnDefs,
			domLayout: 'autoHeight',
		};
	};

	const handleOpenSettingsModal = () => {
		setModalRowData(modalRowData);
		setSettingsModal(true);
	};

	const handleCloseSettingsModal = () => {
		setSettingsModal(false);
	};

	const handleSaveCardSettings = () => {
		setLocalStorageItem(keyToSaveSettings, JSON.stringify(modalRowData));
		setSettingsModal(false);
	};

	function capitalizeFirst(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	const generateBenchmarkAnalysis = data => {
		const result = [];

		data.forEach((item, idx) => {
			let status;
			const name = idx === 0 ? item.name : capitalizeFirst(item.name);
			if (item.clientSpend > item.max) {
				status = `${item.name} above benchmark`;
			} else if (item.clientSpend < item.min) {
				status = `${item.name} below benchmark`;
			} else {
				status = `${item.name} within range`;
			}
			if (idx === 0) {
				status = `${status},`;
			}
			result.push(status);
		});
		return result;
	};

	const generateGeoAnalysis = data => {
		const result = [];
		data.forEach(item => {
			let status = `${item.value2.split('/')[1]} spend coverage ${toPercentage(
				item.value1,
				false
			)}`;
			result.push(status);
		});
		return result;
	};

	const updateKpiVisibility = (mainData, subData) => {
		return mainData.map(kpi => {
			const config = subData.find(configItem => configItem.id === kpi.id);
			if (config) {
				return {
					...kpi,
					isVisible: config.isVisible,
				};
			}
			return kpi;
		});
	};

	const KPItoShow = useMemo(
		() => {
			if (!isLoading) {
				return updateKpiVisibility(kpiData, modalRowData);
			} else {
				return [];
			}
		},
		[isLoading, kpiData, modalRowData]
	);

	const Loader = () => (
		<LoadingContainer>
			<ApLoaderDefault loaderText={() => <ApLoaderText />} />
		</LoadingContainer>
	);

	return (
		<SectionWrapper>
			<LogoWrapper>
				<div>
					<img src={APIcon} alt="Main Icon" height={50} width={50} />
				</div>
				<CompanyNameWrapper>{companyName}</CompanyNameWrapper>
			</LogoWrapper>
			<Wrapper>
				<InsightsBackgroundWrapper>
					<InsightsWrapper>
						<TitleWrapper>
							<Heading>Client Insights</Heading>
						</TitleWrapper>
						<InsightsInfoWrapper id="client-info">
							{isLoading ? <Loader /> : <DynamicGrid data={KPItoShow} />}
						</InsightsInfoWrapper>
					</InsightsWrapper>
				</InsightsBackgroundWrapper>
				<ModulesBackgroundWrapepr>
					<ModulesWrapper>
						<TitleWrapper>
							<Heading>SXR Modules</Heading>
							{!isLoading && (
								<div id="settingIcon">
									<ApButtonIcon
										className="settingIcon"
										title={`Client Insights Settings`}
										iconName="settings"
										onClick={handleOpenSettingsModal}
									/>
								</div>
							)}
						</TitleWrapper>
						<ModulesInfoWrapper>
							<AnalysisModule
								number="1"
								title="Spend Analysis"
								subtitle="What are the top areas of spending?"
								imagePath={SpendAnalysisImg}
								modulePath="/spend"
							/>
							<BenchmarkModule
								number="2"
								title="Benchmark"
								subtitle="How does spend stack up against industry peers?"
								imagePath={BenchmarkImg}
								modulePath="/benchmark/benchmarks"
							/>
							<SupplierDiversityModule
								number="3"
								title="Market Analysis"
								subtitle="What are the alternative vendors?"
								imagePath={DiversityReportImg}
								modulePath="/market-analysis/vendor-database"
							/>

							<APVendorDBModule
								number="4"
								title="Speed to Market"
								subtitle="How to conduct category specific analysis?"
								imagePath={ApVendorDBImg}
								modulePath="/speed-to-market/category-widgets"
							/>
							<CategoryManagementModule
								number="5"
								title="Manage Category"
								subtitle="How to manage category spend?"
								imagePath={CategoryManagementImg}
								modulePath="/category-management/insights"
							/>

							<InitiativesModule
								number="6"
								title="Spend Controller"
								subtitle="How do reduce tail spend?"
								imagePath={InitiativesImg}
								modulePath="/spend-controller/baseline"
							/>
						</ModulesInfoWrapper>
					</ModulesWrapper>
				</ModulesBackgroundWrapepr>
			</Wrapper>
			{SettingsModal && (
				<ApModal
					isOpen={true}
					header="Client Insight Settings"
					isDismissible
					hasClosed={handleCloseSettingsModal}
				>
					<p>Insight</p>
					<TableWrapper>
						<div className="ag-theme-balham">
							<AgGridReact {...getGridOptions()} />
						</div>
						<div style={{ padding: '10px 0 10px 10px' }}>
							<ApButtonMain
								small
								title="Save Settings"
								onClick={handleSaveCardSettings}
							>
								Save
							</ApButtonMain>
						</div>
					</TableWrapper>
				</ApModal>
			)}
		</SectionWrapper>
	);
};

export default SectionOne;
